var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnticlockwisespin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5929 11.2783C32.2306 9.90157 30.6106 8.8066 28.8252 8.05595C27.0398 7.3053 25.124 6.91366 23.1872 6.90339C21.2505 6.89313 19.3306 7.26443 17.5374 7.99612C15.7441 8.7278 14.1125 9.80552 12.7358 11.1678C11.359 12.53 10.2641 14.1501 9.51341 15.9355C8.76276 17.7209 8.37112 19.6366 8.36085 21.5734C8.35059 23.5102 8.72189 25.43 9.45357 27.2232C10.1853 29.0165 11.263 30.6481 12.6252 32.0248",
    stroke: "#F6E200",
    strokeWidth: 4.62695
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3906 11.0723L55.2353 33.1828",
    stroke: "#F6E200",
    strokeWidth: 4.62695
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8779 32.5665C63.2547 31.2043 64.3496 29.5842 65.1003 27.7988C65.8509 26.0134 66.2426 24.0976 66.2529 22.1609C66.2631 20.2241 65.8918 18.3043 65.1601 16.511C64.4285 14.7178 63.3507 13.0862 61.9885 11.7094C60.6263 10.3327 59.0062 9.23769 57.2208 8.48704C55.4354 7.73639 53.5196 7.34475 51.5828 7.33448C49.6461 7.32422 47.7263 7.69552 45.933 8.42721C44.1397 9.15889 42.5082 10.2366 41.1314 11.5988",
    stroke: "#F6E200",
    strokeWidth: 4.62695
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.084 32.3633L39.9734 54.2079",
    stroke: "#F6E200",
    strokeWidth: 4.62695
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1299 39.5565C9.75313 40.9188 8.65816 42.5389 7.90751 44.3243C7.15686 46.1097 6.76522 48.0254 6.75496 49.9622C6.74469 51.899 7.116 53.8188 7.84768 55.612C8.57936 57.4053 9.65708 59.0369 11.0193 60.4136C12.3816 61.7904 14.0016 62.8854 15.787 63.636C17.5724 64.3867 19.4882 64.7783 21.425 64.7886C23.3617 64.7988 25.2815 64.4275 27.0748 63.6958C28.8681 62.9642 30.4996 61.8864 31.8764 60.5242",
    stroke: "#F6E200",
    strokeWidth: 4.62695
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9238 39.7607L33.0344 17.9161",
    stroke: "#F6E200",
    strokeWidth: 4.62695
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7099 61.7227C41.0721 63.0994 42.6922 64.1944 44.4776 64.945C46.263 65.6957 48.1788 66.0873 50.1155 66.0976C52.0523 66.1078 53.9721 65.7365 55.7654 65.0049C57.5586 64.2732 59.1902 63.1955 60.567 61.8332C61.9437 60.471 63.0387 58.8509 63.7893 57.0655C64.54 55.2801 64.9316 53.3643 64.9419 51.4276C64.9521 49.4908 64.5808 47.571 63.8492 45.7777C63.1175 43.9845 62.0398 42.3529 60.6775 40.9761",
    stroke: "#F6E200",
    strokeWidth: 4.62695
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9141 61.9277L18.0694 39.8172",
    stroke: "#F6E200",
    strokeWidth: 4.62695
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnticlockwisespin);
export default __webpack_public_path__ + "static/media/Anticlockwise spin.963efaa98fc6213618b0d19f8bdb08b8.svg";
export { ForwardRef as ReactComponent };